import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

function ConsultaCpfTemCnpj() {
  const [cpf, setCpf] = useState('');
  const [nome, setNome] = useState('');
  const [telefone, setTelefone] = useState('');
  const [resultado, setResultado] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [limiteInfo, setLimiteInfo] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [temPermissao, setTemPermissao] = useState(false);

  useEffect(() => {
    loadUserAndPermissions();
    loadLimiteInfo();
  }, []);

  const loadLimiteInfo = async () => {
    try {
      // Buscar informações de limite (similar ao CPF)
      const response = await axios.get('/users/me');
      if (response.data) {
        // Calcular limite baseado nas informações do usuário
        // Por enquanto, apenas verificar se tem permissão
      }
    } catch (err) {
      console.error('Erro ao carregar informações de limite:', err);
    }
  };

  const loadUserAndPermissions = async () => {
    try {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const user = JSON.parse(userStr);
        setCurrentUser(user);

        // Verificar permissão de CPF TEM CNPJ
        try {
          const response = await axios.get('/users/me');
          const currentUserData = response.data;
          
          if (currentUserData) {
            setCurrentUser(currentUserData);
            localStorage.setItem('user', JSON.stringify(currentUserData));
            
            // Verificar permissão de CPF TEM CNPJ
            setTemPermissao(currentUserData.pode_consultar_cpf_tem_cnpj === true || currentUserData.role === 'admin');
          } else {
            setTemPermissao(user.role === 'admin');
          }
        } catch (err) {
          console.error('Erro ao verificar permissão:', err);
          setTemPermissao(user.role === 'admin');
        }
      }
    } catch (err) {
      console.error('Erro ao carregar usuário:', err);
    }
  };

  // Função para normalizar CPF (remove pontos e traços)
  const normalizarCpf = (cpfInput) => {
    if (!cpfInput) return '';
    return String(cpfInput).replace(/\D/g, '');
  };

  // Função para validar CPF (11 dígitos)
  const validarCpf = (cpfNormalizado) => {
    return cpfNormalizado.length === 11 && /^\d{11}$/.test(cpfNormalizado);
  };

  // Handler para mudança no input de CPF
  const handleCpfChange = (e) => {
    const valor = e.target.value;
    const cpfNormalizado = normalizarCpf(valor);
    
    // Limitar a 11 dígitos
    if (cpfNormalizado.length <= 11) {
      setCpf(cpfNormalizado);
      setError('');
    }
  };

  // Handler para mudança no input de telefone
  const handleTelefoneChange = (e) => {
    const valor = e.target.value;
    const telefoneNormalizado = valor.replace(/\D/g, '');
    
    // Limitar a 15 dígitos (formato brasileiro)
    if (telefoneNormalizado.length <= 15) {
      setTelefone(telefoneNormalizado);
      setError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setResultado(null);
    setLoading(true);

    const cpfNormalizado = normalizarCpf(cpf);

    if (!cpfNormalizado) {
      setError('Por favor, digite um CPF');
      setLoading(false);
      return;
    }

    if (!validarCpf(cpfNormalizado)) {
      setError('CPF inválido. Deve conter exatamente 11 dígitos numéricos');
      setLoading(false);
      return;
    }

    if (!nome || nome.trim() === '') {
      setError('Por favor, digite um nome');
      setLoading(false);
      return;
    }

    // Telefone não é mais obrigatório

    try {
      const response = await axios.post('/consultas-cpf-tem-cnpj/', {
        cpf: cpfNormalizado,
        nome: nome.trim(),
        telefone: telefone.trim() || '' // Telefone opcional, enviar string vazia se não preenchido
      });

      if (response.data.success) {
        // O resultado pode vir diretamente ou dentro de um objeto
        const resultadoRaw = response.data.resultado;
        // Se for objeto com sucesso/empresas, usar diretamente; senão, tentar parsear
        let resultadoFinal = resultadoRaw;
        if (typeof resultadoRaw === 'string') {
          try {
            resultadoFinal = JSON.parse(resultadoRaw);
          } catch (e) {
            resultadoFinal = resultadoRaw;
          }
        }
        setResultado(resultadoFinal);
        // Atualizar informações de limite
        if (response.data.limite !== undefined) {
          setLimiteInfo({
            limite: response.data.limite,
            usadas: response.data.usadas,
            restantes: response.data.restantes
          });
        }
      } else {
        setError(response.data.error || 'Erro ao realizar consulta');
      }
    } catch (err) {
      if (err.response?.data?.error) {
        setError(err.response.data.error);
      } else {
        setError('Erro ao realizar consulta. Tente novamente mais tarde.');
      }
      console.error('Erro ao consultar CPF TEM CNPJ:', err);
    } finally {
      setLoading(false);
    }
  };

  // Função para formatar o resultado
  const formatarResultado = (resultado) => {
    if (!resultado) return null;
    
    // Se for objeto com estrutura de resposta da API
    if (typeof resultado === 'object') {
      // Verificar se tem estrutura de sucesso/empresas
      if (resultado.sucesso !== undefined && resultado.empresas) {
        return {
          sucesso: resultado.sucesso,
          empresas: resultado.empresas
        };
      }
      // Se for array de empresas diretamente
      if (Array.isArray(resultado)) {
        return {
          sucesso: true,
          empresas: resultado
        };
      }
      // Se for objeto com empresas
      if (resultado.empresas && Array.isArray(resultado.empresas)) {
        return {
          sucesso: resultado.sucesso !== false,
          empresas: resultado.empresas
        };
      }
    }
    
    return null;
  };

  if (!temPermissao && currentUser?.role !== 'admin') {
    return (
      <div>
        <nav className="nav">
          <Link to="/dashboard" className="nav-link">
            Dashboard
          </Link>
          <Link to="/consultas" className="nav-link">
            Consultas
          </Link>
          <Link to="/consulta-cpf" className="nav-link">
            Consulta CPF
          </Link>
          <Link to="/consulta-cpf-tem-cnpj" className="nav-link active">
            Consulta CPF TEM CNPJ
          </Link>
          {(currentUser?.role === 'admin' || currentUser?.role === 'proprietario') && (
            <Link to="/admin" className="nav-link">
              Administração
            </Link>
          )}
          {(currentUser?.role === 'admin' || currentUser?.role === 'proprietario') && (
            <Link to="/limites-consultas" className="nav-link">
              Limites
            </Link>
          )}
        </nav>

        <div className="card">
          <h2 style={{ color: '#cc0000' }}>Consulta de CPF TEM CNPJ</h2>
          <div className="alert alert-error">
            <strong>⚠️ Acesso Negado</strong>
            <p style={{ marginTop: '0.5rem', marginBottom: 0 }}>
              Você não tem permissão para consultar CPF TEM CNPJ. Entre em contato com o administrador para solicitar acesso.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <nav className="nav">
        <Link to="/dashboard" className="nav-link">
          Dashboard
        </Link>
        <Link to="/consultas" className="nav-link">
          Consultas
        </Link>
        <Link to="/consulta-cpf" className="nav-link">
          Consulta CPF
        </Link>
        <Link to="/consulta-cpf-tem-cnpj" className="nav-link active">
          Consulta CPF TEM CNPJ
        </Link>
        {(currentUser?.role === 'admin' || currentUser?.role === 'proprietario') && (
          <Link to="/admin" className="nav-link">
            Administração
          </Link>
        )}
        {(currentUser?.role === 'admin' || currentUser?.role === 'proprietario') && (
          <Link to="/limites-consultas" className="nav-link">
            Limites
          </Link>
        )}
      </nav>

      <div className="card">
        <h2 style={{ color: '#cc0000' }}>Consulta de CPF TEM CNPJ</h2>
        <p style={{ color: '#999', marginBottom: '2rem' }}>
          Digite o CPF e nome para verificar se o CPF possui CNPJ associado. Telefone é opcional.
        </p>

        {/* Informações de Limite */}
        {limiteInfo && (
          <div style={{ 
            marginBottom: '2rem', 
            padding: '1rem', 
            backgroundColor: '#1a1a1a', 
            borderRadius: '4px',
            border: '1px solid #333'
          }}>
            <h3 style={{ color: '#cc0000', marginBottom: '0.5rem', fontSize: '1rem' }}>Limite de Consultas de CPF TEM CNPJ</h3>
            {limiteInfo.limite === null ? (
              <p style={{ color: '#00cc66', margin: 0 }}>Ilimitado</p>
            ) : (
              <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                <span style={{ color: '#ccc' }}>
                  Limite: <strong style={{ color: '#cc0000' }}>{limiteInfo.limite}</strong>
                </span>
                <span style={{ color: '#ccc' }}>
                  Usadas: <strong style={{ color: '#ffaa00' }}>{limiteInfo.usadas || 0}</strong>
                </span>
                <span style={{ 
                  color: limiteInfo.restantes === 0 ? '#ff0000' : 
                          (limiteInfo.restantes <= limiteInfo.limite * 0.1 ? '#ff6600' : '#00cc66')
                }}>
                  Restantes: <strong>{limiteInfo.restantes !== null ? limiteInfo.restantes : 'Ilimitado'}</strong>
                </span>
              </div>
            )}
          </div>
        )}

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="nome">Nome</label>
            <input
              type="text"
              id="nome"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              placeholder="Digite o nome completo"
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="telefone">Telefone (opcional)</label>
            <input
              type="text"
              id="telefone"
              value={telefone}
              onChange={handleTelefoneChange}
              placeholder="Digite o telefone (apenas números) - opcional"
              disabled={loading}
            />
            <p style={{ fontSize: '0.85rem', color: '#999', marginTop: '0.5rem' }}>
              Digite apenas números, sem parênteses, traços ou espaços. Campo opcional.
            </p>
          </div>

          <div className="form-group">
            <label htmlFor="cpf">CPF (apenas números)</label>
            <input
              type="text"
              id="cpf"
              value={cpf}
              onChange={handleCpfChange}
              placeholder="Digite o CPF (11 dígitos)"
              maxLength="11"
              pattern="[0-9]*"
              inputMode="numeric"
              required
              disabled={loading}
              style={{ 
                fontFamily: 'monospace',
                fontSize: '1.1rem',
                letterSpacing: '0.1rem'
              }}
            />
            <p style={{ fontSize: '0.85rem', color: '#999', marginTop: '0.5rem' }}>
              Digite apenas números, sem pontos ou traços. O CPF será enviado automaticamente no formato correto.
            </p>
          </div>

          <button 
            type="submit" 
            style={{ backgroundColor: '#cc0000', color: '#fff', border: 'none' }}
            className="btn"
            disabled={loading || !cpf || cpf.length !== 11 || !nome}
          >
            {loading ? 'Consultando...' : 'Consultar CPF TEM CNPJ'}
          </button>
        </form>

        {loading && (
          <div style={{ marginTop: '2rem', textAlign: 'center' }}>
            <div className="loading">Aguardando resposta da API...</div>
          </div>
        )}

        {resultado && !loading && (() => {
          const resultadoFormatado = formatarResultado(resultado);
          
          if (resultadoFormatado && resultadoFormatado.empresas && resultadoFormatado.empresas.length > 0) {
            return (
              <div style={{ 
                marginTop: '2rem', 
                padding: '1.5rem', 
                backgroundColor: '#0a0a0a', 
                borderRadius: '4px',
                border: '1px solid #333'
              }}>
                <h3 style={{ color: '#cc0000', marginBottom: '1rem' }}>Resultado da Consulta</h3>
                <div style={{ 
                  marginBottom: '1rem',
                  padding: '0.75rem',
                  backgroundColor: '#1a1a1a',
                  borderRadius: '4px',
                  border: '1px solid #333'
                }}>
                  <p style={{ color: '#00cc66', margin: 0, fontWeight: 'bold' }}>
                    ✓ CPF possui {resultadoFormatado.empresas.length} {resultadoFormatado.empresas.length === 1 ? 'empresa' : 'empresas'} associada{resultadoFormatado.empresas.length > 1 ? 's' : ''}
                  </p>
                </div>
                
                <div style={{ 
                  display: 'grid',
                  gap: '1rem'
                }}>
                  {resultadoFormatado.empresas.map((empresa, index) => (
                    <div 
                      key={index}
                      style={{ 
                        padding: '1rem',
                        backgroundColor: '#1a1a1a',
                        borderRadius: '4px',
                        border: '1px solid #333',
                        borderLeft: '4px solid #cc0000'
                      }}
                    >
                      <div style={{ marginBottom: '0.5rem' }}>
                        <span style={{ color: '#999', fontSize: '0.85rem' }}>CNPJ: </span>
                        <span style={{ color: '#ccc', fontFamily: 'monospace', fontWeight: 'bold' }}>
                          {empresa.cnpj ? empresa.cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5') : 'N/A'}
                        </span>
                      </div>
                      <div>
                        <span style={{ color: '#999', fontSize: '0.85rem' }}>Razão Social: </span>
                        <span style={{ color: '#fff', fontWeight: '500' }}>
                          {empresa.razao_social || 'N/A'}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          } else {
            // Se não tiver empresas ou formato diferente, mostrar JSON formatado
            return (
              <div style={{ 
                marginTop: '2rem', 
                padding: '1.5rem', 
                backgroundColor: '#0a0a0a', 
                borderRadius: '4px',
                border: '1px solid #333'
              }}>
                <h3 style={{ color: '#cc0000', marginBottom: '1rem' }}>Resultado da Consulta</h3>
                <div style={{ 
                  padding: '0.75rem',
                  backgroundColor: '#1a1a1a',
                  borderRadius: '4px',
                  border: '1px solid #333'
                }}>
                  <p style={{ color: '#ff6600', margin: 0 }}>
                    ⚠️ CPF não possui empresas associadas ou resultado não encontrado
                  </p>
                </div>
                <div style={{ 
                  color: '#ccc', 
                  whiteSpace: 'pre-wrap',
                  fontFamily: 'monospace',
                  fontSize: '0.9rem',
                  lineHeight: '1.6',
                  maxHeight: '600px',
                  overflowY: 'auto',
                  padding: '1rem',
                  backgroundColor: '#000',
                  borderRadius: '4px',
                  border: '1px solid #333',
                  marginTop: '1rem'
                }}>
                  {JSON.stringify(resultado, null, 2)}
                </div>
              </div>
            );
          }
        })()}
      </div>
    </div>
  );
}

export default ConsultaCpfTemCnpj;
